// eslint-disable-next-line @typescript-eslint/no-empty-function
export const _noop = () => { };

export const _isEmpty = (object?: { [key: string | number | symbol]: any } | null) => {
  return object // 👈 null and undefined check
    && Object.keys(object).length === 0
    && Object.getPrototypeOf(object) === Object.prototype;
}